<template>
  <div class="card">
      <div class="card card-custom" >
        <div class="card-header flex-wrap pt-6 pb-0">
          <div class="card-title">
            <h3 class="card-label">{{ $t('projectTypes.list') }}</h3>
          </div>
          <div class="card-toolbar">
            <router-link v-if="$can(abilities.CREATE_CATEGORIES)" :to="{name: 'settings-projects-categories-create'}">
              <Button btn-class="btn-sm" type="new" btn-text="projectTypes.create"/>
            </router-link>
          </div>
        </div>
        <CategoryGroupFilter v-model="tag"/>
        <div class="card-body" >
          <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="kt_datatable_categories" style="margin-top: 13px !important; cursor:pointer">
            <thead>
            <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
              <th class="min-w-200px">{{ $t('categories.name')}}</th>
              <th class="min-w-200px">{{ $t('categories.description')}}</th>
              <th class="w-100px">{{ $t('action') }}</th>
            </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>
</template>

<script setup>

import {computed, nextTick, onMounted, ref, watch} from "vue";
import i18n from '@/plugins/i18n';
import Ls from "@/services/ls";
import {BASE_URL} from "@/services/api";
import {useStore} from "vuex";
import {useHasAbility} from "@/composables/hasAbility";
import { useLocales } from "@/composables/locales";
import Button from "@/components/Button.vue"
import {useSwal} from "@/composables/useSwal";
import {Theme} from "@/composables/theming";
import abilities from "@/composables/abilities";
import {useRouter} from "vue-router";
import CategoryGroupFilter from "../../Projects/components/CategoryGroupFilter.vue";

const {showSwal} = useSwal()
const store = useStore()
const router = useRouter()
const {locale, datatableLocaleUrl} = useLocales()
const currency = computed(() => 'XOF')
const { can } = useHasAbility()

const table = ref()
const tag = ref('')

const formUpdateData = ref({
  id:'',
  name: '',
  description: ''
})

onMounted(() => {
  fetchDatas()
})


watch(() => locale.value, () => {
  nextTick(() => fetchDatas() )
})

watch(() => tag.value, () => {
  nextTick(() => fetchDatas() )
})

function fetchDatas() {
  const AUTH_TOKEN = Ls.get('auth.token')
  const pageLimit = Ls.get('pageLength')

  table.value = $("#kt_datatable_categories").DataTable({
    destroy: true,
    responsive: !0,
    searchDelay: 500,
    processing: !0,
    serverSide: !0,
    pageLength: pageLimit ||  5,
    lengthMenu: [5, 10, 25, 50, 75, 100 ],
    order: [[ 0, 'asc']],
    ajax: {
      url: BASE_URL + "/get/projects/categories/datatables?project_category_group_id="+tag.value,
      type: "GET",
      beforeSend: function (request) {
        request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
      }
    },
    columns: [
      { data: "name" },
      { data: "description" },
      { data: "Actions", responsivePriority: -1 }
    ],
    columnDefs: [
      {
        targets: -3,
        searchable: false,
        className: "dt-center clickable" ,
        render: function (t) {
          return '<span >' + t + "</span>";
        },
      },
       {
        targets: -2,
        orderable: false,
        searchable: false,
        className: "dt-center clickable" ,
        render: function (t) {
          return '<span >' + t + "</span>";
        },
      },
      {
        width: "20%",
        targets: -1,
        "className": "dt-center",
        title: "Actions",
        orderable: false,
        render: function(t, a, e, l) {
          let render=""
          if(can(abilities.UPDATE_CATEGORIES)){
            render+='<a data-id="'+ e.id +'" data-name="'+ e.name +'" data-description="'+ e.description +'"  href="javascript:;"   class="btn btn-sm btn-clean btn-icon edit_btn" title="'+ i18n.global.t('button.edit') +'"><i data-id="'+ e.id +'" data-name="'+ e.name +'" data-description="'+ e.description +'" class="fas fa-edit fs-2"  style="color: '+Theme.gray +'" ></i></a>'
          }
          if(can(abilities.DELETE_CATEGORIES)){
            render += '<a data-id="'+ e.id +'" href="javascript:;" class="btn btn-sm btn-clean btn-icon delete_btn" title="'+ i18n.global.t('button.delete') +'"><i data-id="'+ e.id +'" class="fas fa-trash fs-2" style="color: '+Theme.gray +'" ></i></a>'
          }
          return render
        },
      },
    ],
    language: {
      url: datatableLocaleUrl.value,
    }
  });

  $(document).on("click", "#kt_datatable_categories .edit_btn", (e) => {
    router.push({name: 'settings-projects-categories-edit', params: { id: e.target.getAttribute('data-id') }})
  });

  $(document).on("click", "#kt_datatable_categories .delete_btn", (e) => {
    let id = e.target.getAttribute('data-id')
    deleteCategory(id)
  });
}


async function deleteCategory(id) {
    showSwal(
        '',
        i18n.global.t('categories.category_deleted')
    ).then( async (result) => {
        if (result.value) {
            try {
                await store.dispatch('projectCategories/deleteProjectCategory', id)
                table.value.ajax.reload()
                window.toastr['success'](i18n.global.t("categories.deleted_successfully"))
            }catch (e) {
            }
        }
  })
}



</script>
